import { render, staticRenderFns } from "./RepAdminAddNuera.vue?vue&type=template&id=2c8a184c&scoped=true&"
import script from "./RepAdminAddNuera.vue?vue&type=script&lang=js&"
export * from "./RepAdminAddNuera.vue?vue&type=script&lang=js&"
import style0 from "./RepAdminAddNuera.vue?vue&type=style&index=0&id=2c8a184c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8a184c",
  null
  
)

export default component.exports